export default {
  leftCol: {
    notCollect: "Emblem does not collect any data during this process",
    proofOfAge: "Your proof of age does not allow anyone to trace your online activity",
  },
  rightColIntro: {
    title: "Age Verification",
    poweredBy: "powered by",
    stateLaw: "State law requires you to verify that you are 18 years or older",
    emblemPartner: "We've partnered with Emblem - a trusted age verification system.",
    safeSimple: "It's safe, simple, and only required once.",
    verifyNow: "Verify Now",
    alreadyVerified: "Already verified?",
    login: "Login",
  },
  rightColQR: {
    switchToMobile: "Switch to Mobile Device",
    verificationRequires: "Verification requires a mobile device",
    howToContinue: "How to continue",
    one: "1. Open the camera on your mobile device.",
    two: "2. Scan the QR code.",
    three: "3. Follow the steps on your screen."
  }
}